// Appointments page (pages/Appointments.jsx).
const strings = {
  es: {
    ap_keep: "Volver",
    ap_sub: "Agenda del día, próximas citas y su seguimiento.",
    ap_range_today: "Hoy",
    ap_range_upcoming: "Próximas",
    ap_range_past: "Pasadas",
    ap_range_all: "Todas",
    ap_time_filter: "Periodo",
    ap_all_status: "Todos los estados",
    ap_search_ph: "Buscar paciente o médico…",
    ap_overdue: "Pendiente de cerrar",
    ap_overdue_hint: "La cita ya pasó y sigue como «Agendada». Indica qué ocurrió.",
    ap_empty_upcoming: "No hay próximas citas",
    ap_empty_today: "No hay citas para hoy",
    ap_empty_past: "No hay citas pasadas",
    ap_empty_all: "Aún no hay citas",
    ap_empty_hint: "Agenda una cita para un paciente y aparecerá aquí.",
    ap_empty_filtered: "Ninguna cita coincide con los filtros",
    ap_empty_filtered_hint: "Prueba con otro periodo, estado o búsqueda.",
    ap_clear_filters: "Quitar filtros",
    ap_change_status: "Cambiar estado",
    ap_edit_title: "Editar cita",
    ap_edit_desc: "Reagenda la cita o actualiza el motivo, las notas o el estado.",
    ap_new_desc: "Elige al paciente, el médico y la fecha. Los campos con * son obligatorios.",
    ap_pick_patient: "Buscar paciente por nombre o expediente…",
    ap_select_patient: "Selecciona un paciente",
    ap_no_patients_found: "Ningún paciente coincide",
    ap_patient_doctor_hint: "Médico asignado al paciente: {name}",
    ap_doctor_required_hint: "Elige uno de tus médicos asignados.",
    ap_conflict: "{doctor} ya tiene una cita a las {time} ({patient}). Puedes agendarla de todos modos.",
    ap_conflict_generic: "Este médico ya tiene una cita a las {time} ({patient}). Puedes agendarla de todos modos.",
    ap_datetime: "Fecha y hora",
    ap_delete_title: "¿Eliminar la cita?",
    ap_delete_desc: "Se eliminará la cita de {patient} ({date}). Esta acción no se puede deshacer.",
    ap_delete_suggest: "Si la cita simplemente no se realizará, es mejor cancelarla: así se conserva el historial.",
    ap_cancel_instead: "Cancelar cita en su lugar",
    ap_deleted: "Cita eliminada",
    ap_cancel_title: "¿Cancelar la cita?",
    ap_noshow_title: "¿Marcar como «No asistió»?",
    ap_status_desc: "Cita de {patient} · {date}",
    ap_cancel_appt: "Cancelar cita",
    ap_mark_noshow: "Marcar como no asistió",
    ap_reminder_to: "Recordatorio enviado a {email}",
    ap_no_email: "El paciente no tiene correo registrado",
    ap_sending: "Enviando…",
    ap_prev_month: "Mes anterior",
    ap_next_month: "Mes siguiente",
    ap_add_on_day: "Nueva cita este día",
    ap_no_appts: "sin citas",
    ap_one_appt: "1 cita",
    ap_n_appts: "{n} citas",
    ap_legend: "Estados",
    ap_view: "Vista",
    ap_actions: "Acciones",
  },
  en: {
    ap_keep: "Go back",
    ap_sub: "Today's schedule, upcoming appointments and their follow-up.",
    ap_range_today: "Today",
    ap_range_upcoming: "Upcoming",
    ap_range_past: "Past",
    ap_range_all: "All",
    ap_time_filter: "Period",
    ap_all_status: "All statuses",
    ap_search_ph: "Search patient or doctor…",
    ap_overdue: "Needs closing",
    ap_overdue_hint: "This appointment is past and still “Scheduled”. Record what happened.",
    ap_empty_upcoming: "No upcoming appointments",
    ap_empty_today: "No appointments today",
    ap_empty_past: "No past appointments",
    ap_empty_all: "No appointments yet",
    ap_empty_hint: "Book an appointment for a patient and it will show up here.",
    ap_empty_filtered: "No appointments match the filters",
    ap_empty_filtered_hint: "Try another period, status or search.",
    ap_clear_filters: "Clear filters",
    ap_change_status: "Change status",
    ap_edit_title: "Edit appointment",
    ap_edit_desc: "Reschedule the appointment or update its reason, notes or status.",
    ap_new_desc: "Choose the patient, doctor and date. Fields marked * are required.",
    ap_pick_patient: "Search patient by name or record No.…",
    ap_select_patient: "Select a patient",
    ap_no_patients_found: "No patient matches",
    ap_patient_doctor_hint: "Patient's assigned doctor: {name}",
    ap_doctor_required_hint: "Choose one of your assigned doctors.",
    ap_conflict: "{doctor} already has an appointment at {time} ({patient}). You can still book it.",
    ap_conflict_generic: "This doctor already has an appointment at {time} ({patient}). You can still book it.",
    ap_datetime: "Date and time",
    ap_delete_title: "Delete appointment?",
    ap_delete_desc: "The appointment for {patient} ({date}) will be deleted. This can't be undone.",
    ap_delete_suggest: "If the appointment just won't happen, cancel it instead so the history is kept.",
    ap_cancel_instead: "Cancel appointment instead",
    ap_deleted: "Appointment deleted",
    ap_cancel_title: "Cancel the appointment?",
    ap_noshow_title: "Mark as “No-show”?",
    ap_status_desc: "Appointment for {patient} · {date}",
    ap_cancel_appt: "Cancel appointment",
    ap_mark_noshow: "Mark as no-show",
    ap_reminder_to: "Reminder sent to {email}",
    ap_no_email: "The patient has no email on file",
    ap_sending: "Sending…",
    ap_prev_month: "Previous month",
    ap_next_month: "Next month",
    ap_add_on_day: "New appointment on this day",
    ap_no_appts: "no appointments",
    ap_one_appt: "1 appointment",
    ap_n_appts: "{n} appointments",
    ap_legend: "Statuses",
    ap_view: "View",
    ap_actions: "Actions",
  },
};

export default strings;
